import React, { Component } from 'react';
import '../App.css';
import { withRouter } from 'react-router-dom'
import { getJson } from '../helpers/RequestsHelper'
import { withTranslation } from 'react-i18next';

class CallbackPage extends Component {
    state = {
        loaded: false,
    }
    
    componentDidMount() {
        this.sendCallback(this.props.provider);
    }

    async sendCallback() {
        let url = process.env.REACT_APP_SERVER_BASE_URL + "/oauth/callback" + this.props.location.search;
        if (this.props.location.hash !== undefined) {
            url += "&hash=" + this.props.location.hash.substr(1) 
        }
        await getJson(url);
        this.setState(({ loaded: true }));
        
        const search = this.props.location.search
        const state = search.substr(search.indexOf("state=") + 6);

        var accountId = state.substr(0, state.indexOf("_"))
        const start = state.indexOf("_") + 1
        let end = state.length
        const ampIndex = state.indexOf("&")
        if (ampIndex > start) {
            end = ampIndex
        }
        const redirect = state.substr(start, end - start)

        localStorage.setItem("lastAddedAccount", accountId)

        this.props.history.push(decodeURIComponent(redirect))
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                {this.state.loaded ? t.appaddedsuccess : t.loading}
            </div>
        )
    }
}


export default withRouter(withTranslation()(CallbackPage), CallbackPage);